import { render } from "./ShiftDetails.vue?vue&type=template&id=18780290&scoped=true&ts=true"
import script from "./ShiftDetails.vue?vue&type=script&lang=ts"
export * from "./ShiftDetails.vue?vue&type=script&lang=ts"

import "./ShiftDetails.vue?vue&type=style&index=0&id=18780290&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18780290"]])

export default __exports__